import React from 'react'

function LoadingSpinner() {
  return <div id="spinner" />
}

export default LoadingSpinner
